// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 608) return "static/chunks/608-95f72da7ab199217.js";
	if (chunkId === 334) return "static/chunks/334-2487bdacc71686aa.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"712":"c899f07fde702132","780":"de0da98d60216c9d"}[chunkId] + ".js";
};